export const organizationsTour = {
    module: 'organizations',
    title: 'Organizations Tour',
    title_vi: 'Tour Tổ chức',
    description: 'As the DPO (P-VN-01), configure multi-organization compliance structures, establish department hierarchies, and route data subject requests across your corporate group.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the DPO (P-VN-01), configure multi-organization compliance structures, establish department hierarchies, and route data subject requests across your corporate group.',
    estimated_duration_seconds: 55,
    steps: [
        {
            step_id: 'org_list',
            navigate_to: '/admin/organizations',
            wait_for: '.dm-page',
            target: '.dm-page',
            title: 'Organization List',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Organization List',
            description: 'As the DPO, you will manage all legal entities here. Each organization operates as an isolated tenant with its own compliance data, roles, and regulatory settings -- essential for multi-entity GDPR compliance.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the DPO, you will manage all legal entities here. Each organization operates as an isolated tenant with its own compliance data, roles, and regulatory settings -- essential for multi-entity GDPR compliance.',
            position: 'bottom',
        },
        {
            step_id: 'org_table',
            target: '.dm-table',
            title: 'Browse Organizations',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Browse Organizations',
            description: 'Each row shows the organization name, slug, status, locale, and timezone. Click a row to view or edit the compliance configuration for that entity.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each row shows the organization name, slug, status, locale, and timezone. Click a row to view or edit the compliance configuration for that entity.',
            position: 'bottom',
        },
        {
            step_id: 'org_tabs',
            target: '.dm-tabs',
            title: 'Section Tabs',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Section Tabs',
            description: 'Switch between Organizations (individual entities), Groups (corporate hierarchies for consolidated reporting), and Intake Configurations (data subject request routing).',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Switch between Organizations (individual entities), Groups (corporate hierarchies for consolidated reporting), and Intake Configurations (data subject request routing).',
            position: 'bottom',
        },
        {
            step_id: 'org_create',
            target: '.dm-header .btn-primary',
            title: 'Create an Organization',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create an Organization',
            description: 'Click here to register a new legal entity. Each entity gets its own compliance boundary with separate data processing records and roles.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to register a new legal entity. Each entity gets its own compliance boundary with separate data processing records and roles.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'org_create_form',
            navigate_to: '/admin/organizations/create',
            wait_for: '[data-testid="org-name-input"]',
            target: '.dm-form',
            title: 'Organization Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Organization Form',
            description: 'Enter the organization name, slug, timezone, locale, and optional parent organization. The parent relationship establishes your department hierarchy for consolidated compliance reporting.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter the organization name, slug, timezone, locale, and optional parent organization. The parent relationship establishes your department hierarchy for consolidated compliance reporting.',
            position: 'bottom',
        },
        {
            step_id: 'org_groups',
            navigate_to: '/admin/org-groups',
            wait_for: '.dm-page',
            target: '.dm-page',
            title: 'Organization Groups',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Organization Groups',
            description: 'Groups let you manage multiple entities under a corporate structure, applying shared compliance policies and generating consolidated reports across all subsidiaries.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Groups let you manage multiple entities under a corporate structure, applying shared compliance policies and generating consolidated reports across all subsidiaries.',
            position: 'bottom',
        },
        {
            step_id: 'intake_configs',
            navigate_to: '/admin/intake-configs',
            wait_for: '.dm-page',
            target: '.dm-page',
            title: 'Intake Configurations',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Intake Configurations',
            description: 'Define how data subject requests (GDPR Articles 15-22) are routed into the platform. Each configuration maps an intake key to the correct organization, ensuring requests reach the right DPO.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define how data subject requests (GDPR Articles 15-22) are routed into the platform. Each configuration maps an intake key to the correct organization, ensuring requests reach the right DPO.',
            position: 'bottom',
        },
        {
            step_id: 'create_intake_config',
            target: '.dm-header .dm-btn-primary',
            title: 'Create an Intake Configuration',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create an Intake Configuration',
            description: 'Click here to set up a new intake channel for data subject requests. Each channel maps to a specific organization or group.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to set up a new intake channel for data subject requests. Each channel maps to a specific organization or group.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .dm-btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'intake_config_form',
            target: '.dm-form-modal',
            wait_for: '.dm-form-modal',
            title: 'Intake Configuration Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Intake Configuration Form',
            description: 'Enter a label and intake key, select the routing mode (single org or group), and choose which request types to accept. This ensures data subject rights requests are handled by the correct legal entity.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter a label and intake key, select the routing mode (single org or group), and choose which request types to accept. This ensures data subject rights requests are handled by the correct legal entity.',
            position: 'right',
            action: { type: 'click', target: '.dm-modal-footer button[type="button"]' },
            duration_ms: 300,
        },
        {
            step_id: 'org_complete',
            target: '.dm-page',
            title: 'Organizations Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Organizations Tour Complete',
            description: 'You can now manage multi-entity compliance structures, establish department hierarchies, and route data subject requests to the correct DPO -- ensuring each legal entity meets its GDPR obligations independently.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now manage multi-entity compliance structures, establish department hierarchies, and route data subject requests to the correct DPO -- ensuring each legal entity meets its GDPR obligations independently.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=organizations.js.map